<template>
  <div class="customer-service" @click="handleMenuClick" @mouseover="handleOver" @mouseout="handleOut">
    <img :src="require('@/assets/home/customer-service.png')" />
  </div>
  <div class="customer-qrcode" v-if="model.mouseOver">
    <img :src="require('@/assets/home/service-qrcode.png')" />
  </div>
</template>
<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const model = reactive({
  mouseOver: false,
});
function handleOver() {
  model.mouseOver = true;
}
function handleOut() {
  model.mouseOver = false;
}
function handleMenuClick() {
  router.push("/web/customerService");
}
</script>
<style lang="scss" scoped>
.customer-service {
  position: fixed;
  right: 40px;
  bottom: 150px;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #3395ff 0%, rgba(51, 149, 255, 0.6) 100%);
  border: 2px solid #fff;
  box-shadow: 0px 0px 16px 0px rgba(25, 29, 44, 0.06);
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99;
  img {
    width: 27px;
    height: 27px;
  }
}
.customer-qrcode {
  position: fixed;
  right: 100px;
  bottom: 150px;
  box-shadow: 0px 0px 16px 0px rgba(25, 29, 44, 0.06);
  border-radius: 50%;
  z-index: 99;
  padding: 10px 10px 5px;
  background: #fff;
  border-radius: 4px;
  img {
    width: 150px;
    height: 150px;
  }
}
</style>
        